<template>
  <div class="index" v-cloak>
    <div class="header acea-row row-center-wrapper">
      <div class="logo"><img :src="logoUrl" /></div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <swiper-slide v-for="(item, index) in luckyProductList" :key="index">
          <router-link
                  :to="item.wap_url ? item.wap_url : ''"
                  class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
    <div class="news acea-row row-between-wrapper">
      <div class="pictrue"><img src="@assets/images/news.png" /></div>
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="news acea-row row-between-wrapper" v-if="luckyMsg.length > 0">
      <div class="pictrue" style="color:#0066cc;font-weight: 700;font-size: 15px">活动中奖</div>
      <div class="swiper-no-swiping new-banner">
        <swiper
                class="swiper-wrapper swiper-wrapper2"
                :options="swiperRoll2"
        >
          <swiper-slide
                  class="swiper-slide"
                  v-for="(item, index) in luckyMsg"
                  :key="index"
          >
            <router-link
                    :to="item.url"
                    class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="newsTitle line1">{{ item.content }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="wrapper" v-if="luckyProductList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">抽奖活动</div>
          <div class="line1">购买商品，免费抽奖送积分</div>
        </div>
        <router-link to="/lucky_products" class="more"
        >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
                  class="swiper-slide"
                  v-for="(item, index) in luckyProductList"
                  :key="index"
          >
            <router-link :to="'/detail/'+item.id"
            ><img :src="item.image" style="height: auto"
            /></router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div
      v-if="act.length == 4"
      style="width: 100%;height: 3.95rem;justify-content: space-between;display: flex;flex-direction: column;padding: 0.3rem;"
    >
      <div style="display: flex;justify-content: space-between;">
        <router-link
          :to="activityOne.wap_link ? activityOne.wap_link : ''"
          style="width: 4.16rem;height: 1.6rem;position: relative"
        >
          <img
            style="width: 100%;height: 100%;border-radius: 0.05rem;"
            :src="activityOne.pic"
          />
          <div style="position: absolute;top: 0.37rem;left: 0.22rem;">
            <div style="font-size: 0.3rem;color: #fff;">
              {{ activityOne.title }}
            </div>
            <div
              style="font-size: 0.22rem;color: rgba(255, 255, 255, 0.8);margin-top: 0.05rem;"
            >
              {{ activityOne.info }}
            </div>
          </div>
        </router-link>
        <router-link
          :to="activityTwo.wap_link ? activityTwo.wap_link : ''"
          style="height: 1.6rem;width: 2.6rem;position: relative"
        >
          <img
            style="width: 100%;height: 100%;border-radius: 0.05rem;"
            :src="activityTwo.pic"
          />
          <div style="position: absolute;top: 0.37rem;left: 0.22rem;">
            <div style="font-size: 0.3rem;color: #fff;">
              {{ activityTwo.title }}
            </div>
            <div
              style="font-size: 0.22rem;color: rgba(255, 255, 255, 0.8);margin-top: 0.05rem;"
            >
              {{ activityTwo.info }}
            </div>
          </div>
        </router-link>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <router-link
          :to="activityThree.wap_link ? activityThree.wap_link : ''"
          style="height: 1.6rem;width: 2.6rem;position: relative"
        >
          <img
            style="width: 100%;height: 100%;border-radius: 0.05rem;"
            :src="activityThree.pic"
          />
          <div style="position: absolute;top: 0.37rem;left: 0.22rem;">
            <div style="font-size: 0.3rem;color: #fff;">
              {{ activityThree.title }}
            </div>
            <div
              style="font-size: 0.22rem;color: rgba(255, 255, 255, 0.8);margin-top: 0.05rem;"
            >
              {{ activityThree.info }}
            </div>
          </div>
        </router-link>
        <router-link
          :to="activityFour.wap_link ? activityFour.wap_link : ''"
          style="height: 1.6rem;width: 4.16rem;position: relative"
        >
          <img
            style="width: 100%;height: 100%;border-radius: 0.05rem;"
            :src="activityFour.pic"
          />
          <div style="position: absolute;top: 0.37rem;left: 0.22rem;">
            <div style="font-size: 0.3rem;color: #fff;">
              {{ activityFour.title }}
            </div>
            <div
              style="font-size: 0.22rem;color: rgba(255, 255, 255, 0.8);margin-top: 0.05rem;"
            >
              {{ activityFour.info }}
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="wrapper" v-if="info.fastList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">快速选择</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="scroll-product">
        <swiper class="swiper-wrapper" :options="swiperScroll">
          <swiper-slide
            v-for="(item, index) in info.fastList"
            :key="index"
            class="swiper-slide"
          >
            <router-link
              :to="{
                path: '/goods_list',
                query: { id: item.id, title: item.cate_name }
              }"
            >
              <div class="img-box">
                <img :src="item.pic" />
              </div>
              <div class="pro-info line1">{{ item.cate_name }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="wrapper" v-if="info.bastList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
    </div>
    <div class="hotList" v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
            <img
              src="@assets/images/one.png"
              class="numPic"
              v-if="index === 0"
            />
            <img
              src="@assets/images/two.png"
              class="numPic"
              v-else-if="index === 1"
            />
            <img
              src="@assets/images/three.png"
              class="numPic"
              v-else-if="index === 2"
            />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            ￥<span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div v-if="lovely.img">
      <div class="adver">
        <img :src="lovely.img" />
      </div>
    </div>
    <div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首发新品<span class="new font-color-red">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="img-box">
                <img :src="item.image" />
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">￥{{ item.price }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="wrapper" v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促销单品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="'/promotion'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div>
    <Promotion-good :benefit="benefit"></Promotion-good>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { getLuckyProducts,luckyAlist } from "@api/store";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow
  },
  props: {},
  data: function() {
    return {
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      activityTwo: {},
      activityThree: {},
      activityFour: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      luckyMsg: [],
      luckyProductList: [],
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      act: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll2: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    let that = this;
    this.getLuckyMsgList()
    this.getLuckyProductList()
    getHomeData().then(res => {
      that.logoUrl = res.data.logoUrl;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      this.act = JSON.parse(JSON.stringify(res.data.activity))
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        let activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
        let activityTwo = res.data.activity.shift();
        that.$set(that, "activityTwo", activityTwo);
        let activityThree = res.data.activity.shift();
        that.$set(that, "activityThree", activityThree);
        let activityFour = res.data.activity.shift();
        that.$set(that, "activityFour", activityFour);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(that, "lovely", res.data.lovely);
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
    });
  },
  methods: {
    getLuckyMsgList: function() {
      let that = this
      luckyAlist()
              .then(res => {
                that.luckyMsg = res.data;
              })
              .catch(function(res) {
                this.$dialog.toast({ mes: res.msg });
              });
    },
    getLuckyProductList: function() {
      let that = this
      getLuckyProducts({limit: 3})
              .then(res => {
                that.luckyProductList = res.data;
              })
              .catch(function(res) {
                this.$dialog.toast({ mes: res.msg });
              });
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
</style>
